import { render, staticRenderFns } from "./DefaultCharges.vue?vue&type=template&id=14a328cd&scoped=true&"
import script from "./DefaultCharges.vue?vue&type=script&lang=js&"
export * from "./DefaultCharges.vue?vue&type=script&lang=js&"
import style0 from "./DefaultCharges.vue?vue&type=style&index=0&id=14a328cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a328cd",
  null
  
)

export default component.exports